import { CaretDownIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu, Flex, Slider, Text } from '@radix-ui/themes';
import { useTranslation } from '../../../i18n';
import { useEditorStore } from '../../../stores';

const ZOOM_MIN_PERCENT = 10;
const ZOOM_MAX_PERCENT = 400;

export function ZoomTools() {
  const { t } = useTranslation();
  const { zoom, setZoom, zoomIn, zoomOut, resetZoom } = useEditorStore();
  const percent = Math.round(zoom * 100);

  return (
    <div className="zoom-tools">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button
            variant="soft"
            radius="none"
            size="3"
            className="zoom-tools-trigger"
            aria-label={t('toolbar.zoomPercent', { percent })}
          >
            <MagnifyingGlassIcon aria-hidden="true" />
            <span className="zoom-tools-percent">{percent}%</span>
            <CaretDownIcon aria-hidden="true" className="zoom-tools-chevron" />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          variant="soft"
          size="2"
          align="center"
          sideOffset={4}
          className="zoom-tools-dropdown"
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          <div
            className="zoom-tools-panel"
            onPointerDown={(e) => e.preventDefault()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Flex align="center" justify="between" mb="2">
              <Text size="1" color="gray">
                {t('toolbar.zoom')}
              </Text>
              <Text size="1" weight="medium" className="zoom-tools-panel-value">
                {percent}%
              </Text>
            </Flex>
            <Slider
              size="1"
              min={ZOOM_MIN_PERCENT}
              max={ZOOM_MAX_PERCENT}
              step={5}
              value={[percent]}
              onValueChange={([value]) => setZoom(value / 100)}
              aria-label={t('toolbar.zoomLevel')}
            />
            <Flex gap="2" mt="3" justify="between">
              <Button size="1" variant="soft" onClick={() => zoomOut()} aria-label={t('toolbar.zoomOut')}>
                −
              </Button>
              <Button size="1" variant="soft" onClick={() => resetZoom()}>
                100%
              </Button>
              <Button size="1" variant="soft" onClick={() => zoomIn()} aria-label={t('toolbar.zoomIn')}>
                +
              </Button>
            </Flex>
            <Flex gap="1" mt="2" wrap="wrap">
              {[50, 100, 150, 200].map((preset) => (
                <Button
                  key={preset}
                  size="1"
                  variant={percent === preset ? 'solid' : 'ghost'}
                  onClick={() => setZoom(preset / 100)}
                >
                  {preset}%
                </Button>
              ))}
            </Flex>
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
